"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const AnswerCardBox_1 = __importDefault(require("./AnswerCardBox"));
const helpers_1 = require("@app/helpers");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const exercise_1 = require("@components/container/exercise");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const Pagination_1 = require("@components/Pagination");
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const useBeforeUnloadReport_1 = require("@hooks/useBeforeUnloadReport");
const DropContainerWrapper = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  align-items: self-start;
  justify-content: end;
  height: 100%;
  @media (max-width: 1200px) {
    justify-content: center;
  }
  @media (max-width: 700px) {
    flex-wrap: wrap-reverse;
  }
`;
let index = 0;
let timeoutId = null;
let newRepeatAgain = null;
let wrongAnswerCount = 0;
let infoRep = [];
let checkedAnswer = [];
function checkOrder(array1, array2) {
    const length1 = array1.length;
    for (let i = 0; i <= array2.length - length1; i++) {
        let isInOrder = true;
        for (let j = 0; j < length1; j++) {
            if (array2[i + j] !== array1[j]) {
                isInOrder = false;
                break;
            }
        }
        if (isInOrder) {
            return true;
        }
    }
    return false;
}
const Prepositions = ({ response, description, langId }) => {
    const [data, setData] = (0, react_1.useState)([]);
    const [initialData, setInitialData] = (0, react_1.useState)([]);
    const [recognizer, setRecognizer] = (0, react_1.useState)(null);
    const [isRecognizing, setIsRecognizing] = (0, react_1.useState)(false);
    const [currentCardIndex, setCurrentCardIndex] = (0, react_1.useState)(0); // Индекс текущей карточки
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    (0, useBeforeUnloadReport_1.useBeforeUnloadReport)(() => ({ infoRep, exerciseId: (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), checkedAnswer }));
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    const recognizedWords = (0, react_1.useRef)([]);
    const [checkButtons, setCheckButtons] = (0, react_1.useState)((0, helpers_1.generateInitialState)(10));
    const startRecognition = (options, itemData) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const newOptions = (_a = itemData === null || itemData === void 0 ? void 0 : itemData.question) === null || _a === void 0 ? void 0 : _a.replace('*', options[0]).split(' ');
            const cleanedOptions = newOptions.map(word => word.replace(/[.,]/g, ''));
            const stream = yield window.navigator.mediaDevices.getUserMedia({
                audio: {
                    sampleRate: 16000,
                    sampleSize: 16,
                    channelCount: 1,
                },
            });
            // @ts-ignore
            const recognizerInstance = new window.RecognizerSpeechDev([...cleanedOptions]);
            yield recognizerInstance.init(stream, langId);
            setRecognizer(recognizerInstance);
            setIsRecognizing(true);
            if (itemData === null || itemData === void 0 ? void 0 : itemData.audio) {
                audioPlayer_1.audioPlayer.stopAudio();
                audioPlayer_1.audioPlayer.playAudio('', itemData === null || itemData === void 0 ? void 0 : itemData.audio);
            }
            document.addEventListener('recognizeWordEvent', (e) => handleRecognizeWordEvent(e, cleanedOptions));
            timeoutId = setTimeout(() => {
                recognizedWords.current = [];
                handleAnswer(false);
                wrongAnswerCount++;
            }, 23000);
        }
        catch (error) {
            console.error('Error accessing microphone:', error);
        }
    });
    const stopRecognition = () => {
        if (recognizer) {
            recognizer.stop();
            recognizedWords.current = [];
            setIsRecognizing(false);
            index = 0;
            setCurrentCardIndex(0);
            setCheckButtons(uiConfigs_1.initialButtonState);
        }
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    };
    const handleRecognizeWordEvent = (e, newOptions) => {
        var _a;
        const word = ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.word) || '';
        if (!recognizedWords.current.includes(word)) {
            recognizedWords.current.push(word); // Добавляем слово только если его еще нет
        }
        const isCorrect = checkOrder(newOptions, recognizedWords.current);
        if (isCorrect) {
            wrongAnswerCount = 0;
            clearTimeout(timeoutId); // Очищаем таймер при правильном ответе
        }
        const updatedData = data === null || data === void 0 ? void 0 : data.map((item, idx) => {
            if ((isCorrect) && ((index || currentCardIndex) === idx)) {
                return (Object.assign(Object.assign({}, item), { isCorrect: true }));
            }
            return item;
        });
        setData(updatedData);
        setTimeout(() => {
            var _a, _b;
            if (!isCorrect && recognizedWords.current.includes((_b = (_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.answer) === null || _b === void 0 ? void 0 : _b.toLowerCase())) {
                audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 317));
                recognizedWords.current = [];
            }
        }, 3000);
        if (isCorrect) {
            recognizedWords.current = [];
            setCheckButtons((prevButtons) => {
                const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                if (indexToUpdate === -1)
                    return prevButtons;
                const updatedButtons = prevButtons.map((button, idx) => {
                    if (idx === indexToUpdate) {
                        return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: isCorrect });
                    }
                    return button;
                });
                checkedAnswer = updatedButtons;
                return updatedButtons;
            });
            clearTimeout(timeoutId);
        }
        if (isCorrect) {
            wrongAnswerCount = 0;
            if (newRepeatAgain) {
                clearTimeout(newRepeatAgain);
            }
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            handleAnswer(isCorrect, false);
        }
    };
    (0, react_1.useEffect)(() => {
        return () => {
            if (recognizer) {
                recognizer.stop();
            }
            document.removeEventListener('recognizeWordEvent', (e) => handleRecognizeWordEvent(e, ['']));
        };
    }, [recognizer]);
    const handleButtonClick = () => {
        var _a;
        if (isRecognizing) {
            stopRecognition();
            // @ts-ignore
            window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
            // @ts-ignore
            (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
        }
        else {
            startRecognition([(_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.answer.toLowerCase()], data[index || currentCardIndex]);
        }
    };
    const handleAnswer = (isCorrect, isTimer) => {
        infoRep = (0, sendInfoReport_1.trackAttemptTime)(infoRep, isCorrect);
        if (isCorrect) {
            if (timeoutId) {
                clearInterval(timeoutId);
            }
            wrongAnswerCount = 0;
            handleAddCoin();
            setTimeout(() => {
                var _a, _b, _c;
                const nextIndex = index + 1;
                recognizedWords.current = [];
                if (data[nextIndex]) {
                    setCurrentCardIndex(nextIndex);
                    index = nextIndex;
                    infoRep = [...infoRep, { rep_id: ((_a = data[nextIndex]) === null || _a === void 0 ? void 0 : _a.id) || nextIndex + 1, category_name: '', system_time: '', startTime: Date.now() }];
                    stopRecognition();
                    startRecognition([(_c = (_b = data[nextIndex]) === null || _b === void 0 ? void 0 : _b.right_word) === null || _c === void 0 ? void 0 : _c.toLowerCase()], data[nextIndex]);
                }
                else {
                    setIsRecognizing(false);
                    stopRecognition();
                    // @ts-ignore
                    window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                    // @ts-ignore
                    (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                }
            }, 4000);
        }
        else {
            recognizedWords.current = [];
            if (wrongAnswerCount >= 3) {
                const nextIndex = index + 1;
                setCheckButtons((prevButtons) => {
                    const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                    if (indexToUpdate === -1)
                        return prevButtons;
                    const updatedButtons = prevButtons.map((button, idx) => {
                        if (idx === indexToUpdate) {
                            return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: false });
                        }
                        return button;
                    });
                    checkedAnswer = updatedButtons;
                    return updatedButtons;
                });
                recognizedWords.current = [];
                wrongAnswerCount = 0;
                stopRecognition();
                const updatedData = data === null || data === void 0 ? void 0 : data.map((item, idx) => {
                    if (index === idx) {
                        return (Object.assign(Object.assign({}, item), { isCorrect: false }));
                    }
                    return item;
                });
                audioPlayer_1.audioPlayer.stopAudio();
                audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 315));
                setTimeout(() => {
                    var _a;
                    audioPlayer_1.audioPlayer.stopAudio();
                    audioPlayer_1.audioPlayer.playAudio('x', (_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.right_audio);
                    wrongAnswerCount++;
                }, 2000);
                setData(updatedData);
                setTimeout(() => {
                    var _a, _b, _c;
                    if (data[nextIndex]) {
                        index = nextIndex;
                        recognizedWords.current = [];
                        setCurrentCardIndex(nextIndex);
                        infoRep = [...infoRep, { rep_id: ((_a = data[nextIndex]) === null || _a === void 0 ? void 0 : _a.id) || nextIndex + 1, category_name: '', system_time: '', startTime: Date.now() }];
                        stopRecognition();
                        startRecognition([(_c = (_b = data[nextIndex]) === null || _b === void 0 ? void 0 : _b.right_word) === null || _c === void 0 ? void 0 : _c.toLowerCase()], data[nextIndex]);
                    }
                    else {
                        // @ts-ignore
                        window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                        // @ts-ignore
                        (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                    }
                }, 4500);
            }
            else {
                if (wrongAnswerCount !== 3 && isTimer) {
                    audioPlayer_1.audioPlayer.stopAudio();
                    audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 318));
                }
            }
        }
    };
    const windowWidth = (0, useWindowWidrh_1.default)();
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (response) {
            setData(response === null || response === void 0 ? void 0 : response.data);
            const initialState = (0, helpers_1.generateInitialState)((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length);
            setCheckButtons(initialState);
            checkedAnswer = initialState;
            setInitialData(response === null || response === void 0 ? void 0 : response.data);
            infoRep = [{ rep_id: ((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id) || 1, category_name: '', system_time: '', startTime: Date.now() }];
        }
    }, [response]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, { wihMargin: windowWidth <= 1200 },
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(AnswerCardBox_1.default, { list: [data[index || currentCardIndex]] }),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { isShowShadow: true, isStarted: isRecognizing, label: (0, translations_1.getLabelPauseButton)(langId, isRecognizing), isCheckButton: false, onClick: handleButtonClick }))))));
};
exports.default = Prepositions;
